import React from 'react';
import lockIcon from './lock.png';
import { Link, RouteComponentProps } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import AuthStatusPage from 'components/auth/AuthStatusPage';
import { HyperLink } from 'styles/Styles.styled';

const ResetPasswordSuccess: React.FC<RouteComponentProps> = () => {
  return (
    <AuthStatusPage
      imageSrc={lockIcon}
      imageAlt="Success"
      title="Your password has been reset!"
      link={
        <HyperLink as={Link} to={EpdRoutes.login}>
          Back to login page
        </HyperLink>
      }
    />
  );
};

export default ResetPasswordSuccess;
